<script>
export default {
  methods: {
    async onDetect (resultPromise, onDecode) {
      this.$emit('detect', resultPromise)
      try {
        const { content } = await resultPromise
        if (content !== null) {
          if (onDecode) {
            onDecode(content)
          } else {
            this.$emit('decode', content)
          }
        }
      } catch (error) {
        // fail silently
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/CommonAPI.vue